import React, { useState, useEffect } from 'react';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import axios from 'axios';
import PropTypes from "prop-types";
import { Table, Badge, Button, Modal, Form } from 'react-bootstrap';
import AddTagCharge from './PopUps/Add/AddTagCharge';
import EditTagCharge from './PopUps/Edit/EditTagCharge';
import * as Icon from 'react-feather';
import { canPageAction } from '../../config/roleConfig';
import DeactivateConfirmModal from '../Common/DeactivateConfirmModal';

function NewTagCharge(props)  {
    const authHeader = useAuthHeader();
    const authUser = useAuthUser();
    const currentUser = authUser();
    const canRead = canPageAction(currentUser, 'finance.tag', 'read');
    const canWrite = canPageAction(currentUser, 'finance.tag', 'write');
    const canDelete = canPageAction(currentUser, 'finance.tag', 'delete');

    const [data, setData] = useState([]);
    const [inventoryOptions, setInventoryOptions] = useState([]);
    const [selectedInventoryId, setSelectedInventoryId] = useState('');
    const [expandedTagCharge, setExpandedTagCharge] = useState(null);
    const [tagChargeToDeactivate, setTagChargeToDeactivate] = useState(null);
    const [deactivatingTagCharge, setDeactivatingTagCharge] = useState(false);
    const apiUrl = process.env.REACT_APP_URL;

    const get_all_data = (inventoryId = '') => {
        let url = apiUrl + '/finance/tag_charge';
        if (inventoryId) {
            url += `?inventory_id=${inventoryId}`;
        }

        axios({
            method:'GET',
            url: url,
            headers: {
                Authorization: authHeader()
            },
        }).then(response => {
            setData(response.data.msg.TagCharges);
        })
        .catch(error => {
            alert(error);
            console.log(error);
        });
    }

    const get_inventory_options = () => {
        axios({
            method: 'GET',
            url: apiUrl + '/units/get_all_units',
            headers: {
                Authorization: authHeader()
            },
        }).then(response => {
            setInventoryOptions(response.data.msg.Units);
        })
        .catch(error => {
            console.error('Error fetching inventory options:', error);
        });
    }

    useEffect(() => {
        get_inventory_options();
    }, []);

    useEffect(() => {
        if (inventoryOptions.length > 0) {
            const firstUnitId = inventoryOptions[0].id;
            setSelectedInventoryId(firstUnitId);
            get_all_data(firstUnitId);
        }
    }, [inventoryOptions]);

    const handleInventoryChange = (e) => {
        const inventoryId = e.target.value;
        setSelectedInventoryId(inventoryId);
        get_all_data(inventoryId);
    };

    const toggleTagChargeDetails = (tagChargeId) => {
        setExpandedTagCharge(expandedTagCharge === tagChargeId ? null : tagChargeId);
    };

    const deleteTagCharge = (tagCharge) => {
        if (!tagCharge) {
            return;
        }

        setDeactivatingTagCharge(true);
        axios({
            method: 'DELETE',
            url: apiUrl + '/finance/tag_charge',
            headers: {
                Authorization: authHeader()
            },
            data: { id: tagCharge.id }
        }).then(() => {
            setTagChargeToDeactivate(null);
            get_all_data(selectedInventoryId);
        }).catch(error => {
            alert(error.response?.data?.error || 'No se pudo desactivar la carga de Tag');
            console.log(error);
        }).finally(() => {
            setDeactivatingTagCharge(false);
        });
    };

        return (
            <>
            <div className="card mb-4">
                <div className="card-body">
                    <div className="card-header d-flex justify-content-between">
                        <h5 className="card-title">Registros</h5>
                        {canWrite && <AddTagCharge setData={() => get_all_data(selectedInventoryId)}/>}
                    </div>

                    <div className="mb-3 d-flex align-items-center">
                        <Form.Group className="d-flex align-items-center">
                            <Form.Label className="me-2 mb-0" style={{whiteSpace: 'nowrap'}}>Filtrar por Unidad:</Form.Label>
                            <Form.Select
                                value={selectedInventoryId}
                                onChange={handleInventoryChange}
                                style={{width: '250px'}}
                            >
                                <option value="">Todas las unidades</option>
                                {inventoryOptions.map(inventory => (
                                    <option key={inventory.id} value={inventory.id}>
                                        {inventory.inventory_name || inventory.name}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </div>

                    {/* <div className="height-310"> */}
                    <div>
                        <Table className="m-0" responsive>
                            <thead>
                                <tr>
                                    <th>Unidad</th>
                                    <th>Fecha</th>
                                    <th>Total</th>
                                    <th>Folio Fiscal Factura</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map(tag_charge => (
                                    <React.Fragment key={tag_charge.id}>
                                        <tr>
                                            <td>{tag_charge.inventory_name}</td>
                                            <td>{tag_charge.date_loaded}</td>
                                            <td>${tag_charge.total}</td>
                                            <td>{tag_charge.invoice_id}</td>
                                            <td>
                                                <div className="d-flex gap-1">
                                                    {canRead && (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-primary"
                                                            onClick={() => toggleTagChargeDetails(tag_charge.id)}
                                                        >
                                                            <Icon.Eye size={14} />
                                                        </Button>
                                                    )}
                                                    {canWrite && <EditTagCharge setData={() => get_all_data(selectedInventoryId)} dieselInfo={tag_charge}/>}
                                                    {canDelete && (
                                                        <Button
                                                            size="sm"
                                                            variant="outline-danger"
                                                            onClick={() => setTagChargeToDeactivate(tag_charge)}
                                                        >
                                                            <Icon.Trash2 size={14} />
                                                        </Button>
                                                    )}
                                                    {!canRead && !canWrite && !canDelete && (
                                                        <span className="text-muted">N/A</span>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                        {expandedTagCharge === tag_charge.id && (
                                            <tr>
                                                <td colSpan={5}>
                                                    <div className="p-3 bg-light">
                                                        <p className="mb-1"><strong>Unidad:</strong> {tag_charge.inventory_name}</p>
                                                        <p className="mb-1"><strong>Total:</strong> ${tag_charge.total}</p>
                                                        <p className="mb-0"><strong>Folio Fiscal:</strong> {tag_charge.invoice_id || 'N/A'}</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
            <DeactivateConfirmModal
                show={Boolean(tagChargeToDeactivate)}
                title="Desactivar Carga de Tag"
                itemLabel={tagChargeToDeactivate?.inventory_name}
                confirming={deactivatingTagCharge}
                onCancel={() => !deactivatingTagCharge && setTagChargeToDeactivate(null)}
                onConfirm={() => deleteTagCharge(tagChargeToDeactivate)}
            />
            </>
        );

}

//Status: Entregado, Pendiente, Cancelado, En camino
// Success, Warning, Danger, Info
//https://react-bootstrap.netlify.app/docs/components/badge/
export default NewTagCharge;
